import axios from 'axios';
const API_BASE_URL = process.env.NODE_ENV === "production" ? 'https://backend.successtutorial.org' : 'http://localhost:5000'

// create axios instance with default config
const apiClient = axios.create({
    baseURL : API_BASE_URL,
    timeout : 30000,    
    withCredentials: true,
})

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // Don't retry on auth/login endpoints
    if (originalRequest.url.includes('/api/auth/admin/login') || 
        originalRequest.url.includes('/api/auth/admin/refresh') ||
        originalRequest.url.includes('auth/admin/login') || 
        originalRequest.url.includes('auth/admin/refresh')) {
      return Promise.reject(error);
    }

    // Handle 401 (Unauthorized) - Try to refresh token
    if (error.response?.status === 401 && !originalRequest._retry) {
      // Don't retry on auth/login endpoints or if refresh endpoint doesn't exist
  if (originalRequest.url.includes('/auth/admin/me') && 
      error.response?.status === 401 && 
      originalRequest._retryCount === undefined) {
    
    // For the initial auth check, don't try to refresh if we know refresh endpoint is 404
    console.log("⚠️ Skipping refresh for initial auth check");
    return Promise.reject(error);
  }

      // if (isRefreshing) {
      //   // If already refreshing, add to queue
      //   return new Promise((resolve, reject) => {
      //     failedQueue.push({ resolve, reject });
      //   })
      //     .then(() => {
      //       return apiClient(originalRequest);
      //     })
      //     .catch(err => {
      //       return Promise.reject(err);
      //     });
      // }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        console.log('🔄 Attempting token refresh...');
        
        // Try to refresh token - use relative path
        await apiClient.post('api/auth/admin/refresh');
        
        console.log('✅ Token refresh successful');
        processQueue(null);
        
        // Retry the original request with new token
        return apiClient(originalRequest);
        
      } catch (refreshError) {
        console.log('❌ Token refresh failed:', refreshError.response?.status);
        
        // Refresh failed - clear all auth data
        processQueue(refreshError, null);
        
        // Only redirect if not already on login page
        if (!window.location.pathname.includes('admin-login')) {
          window.location.href = '/admin-login?session=expired';
        }
        
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    // Handle rate limiting
    if (error.response?.status === 429) {
      const retryAfter = error.response.headers['retry-after'] || 5;
      console.log(`⏳ Rate limited. Retrying after ${retryAfter} seconds...`);
      
      // Wait and retry once
      await new Promise(resolve => setTimeout(resolve, retryAfter * 1000));
      
      if (!originalRequest._retryCount) {
        originalRequest._retryCount = 1;
        return apiClient(originalRequest);
      }
      
      // Don't redirect for rate limits on auth endpoints
      if (!originalRequest.url.includes('auth/')) {
        window.location.href = "/login?error=rate_limit_exceeded";
      }
    }
    
    return Promise.reject(error);
  }
);




// Add request interceptor to log all requests
apiClient.interceptors.request.use(
  (config) => {
    // console.log(`🚀 ${config.method?.toUpperCase()} ${config.baseURL}${config.url}`, config.data);
    return config;
  },
  (error) => {
    console.error('❌ Request error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor to log all responses
apiClient.interceptors.response.use(
  (response) => {
    // console.log(`✅ ${response.config.url} - Status: ${response.status}`, response.data);
    return response;
  },
  (error) => {
    console.error('❌ Response error:', {
      url: error.config?.url,
      status: error.response?.status,
      data: error.response?.data
    });
    return Promise.reject(error);
  }
);


// for students 

export {apiClient}